import React, { useRef, useState } from "react";
import { SUB_DIRECTORY } from "../../common/constant";
import moment from "moment";
import { numDifferentiation } from "../../common/app_constant";
import _ from "lodash";
import { useDispatch } from "react-redux";
import DocumentCard from "../document_card";
import { useNavigate } from 'react-router-dom';

const ClaimCard = props => {
  const [clicked, setClicked] = useState("0");
  const contentEl = useRef();
  const navigate = useNavigate();
  console.log(JSON.stringify(props.detail))
  const handleToggle = index => {
    if (clicked === index) {
      return setClicked("0");
    }
    setClicked(index);
  };

  const renderDocuments = item => {
    var arrDoc = [];

    item != null && item?.length > 0
      ? item.map((item, index) => {
        arrDoc.push(
          <div className="col-md-6 mb-2">
            <DocumentCard
             policyData={props.detail?.policy_detail}
              detailDocument={item}
              claim={true}
              actionDownload={props.actionDownload}
            />
          </div>
        );
      })
      : arrDoc.push(
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">No Documents Uploaded</div>
          </div>
        </div>
      );

    return arrDoc;
  };

  return (
    <>
    <span  onClick={() => {
          handleToggle(props.detailIndex);
        }}
        style={{ cursor: "pointer" }}>
    <div className="card-header">
    <small>Pinc Claim Ref. No : <b>{props?.detail?.pinc_claim_ref_no}</b></small>
    </div>
       <div className="card-body">
                          <div className="accordion">
      <div
        className="row"
       
      >
        {/* <div className="col-1 text-center my-auto">
          <img
            src={`${SUB_DIRECTORY}/assets/images/claim.png`}
            className="w-50"
            alt=""
          />
        </div> */}
        <div className="col-11 col-md-3">
          <p className="mb-0 fw-600">
            {_.capitalize(props?.detail?.policy_detail?.userDetails?.full_name)}
          </p>
          <small>Policy NO. : <a className="text-danger"
            onClick={() => {
              navigate("/policies");
            }}
          >{props?.detail?.policy_detail?.policy_no}</a></small><br/>
        
        </div>
        <div className="col-6 col-md-3 mt-2 mt-md-0">
          {/* Loss Amount */}
          <p className="mb-0">Claimed Amount</p>
          <p className="mb-0 fw-bold">
            {props?.detail?.loss_amount != null ? `₹ ${numDifferentiation(props?.detail?.loss_amount)}` : '-'}
          </p>
        </div>
        <div className="col-6 col-md-2 mt-2 mt-md-0">
          <p className="mb-0">Settled Amount</p>
          <p className="mb-0 fw-bold">
            {props?.detail?.settlement_amount != null ? `₹ ${numDifferentiation(props?.detail?.settlement_amount)}` : '-'}
          </p>
        </div>
        <div className="col-6 col-md-3 text-center mt-2 mt-md-0">
          <span className="badge bg-primary rounded-pill">
            {_.capitalize(props.detail.status)}
          </span>
        </div>
      </div>

      <div
        ref={contentEl}
        hidden={clicked === props.detailIndex ? false : true}
      >
        <div
          className="row border-top pt-2 mt-1"
        >
          <div className="col-12 col-md-4 mt-2">
            <label className="card-label">Policy Type :</label>
            <p className="card-value mb-0">
              {" "}
              {props.detail?.policy_detail?.policy_type}
            </p>
          </div>
          <div className="col-6 col-md-4 mt-2">
            <label className="card-label">Intimation Date :</label>
            <p className="card-value mb-0">
              {props?.detail?.final_intimation_date != null
                ? moment(props?.detail?.final_intimation_date).format("DD/MM/YYYY")
                : "-"}
            </p>
          </div>
          {/* <div className="col-6 col-md-4 mt-2">
          <label className="card-label text-primary">Pinc Ref. No : </label>
          <p className="card-value mb-0">{props.detail.pinc_claim_ref_no}</p>
        </div> */}
          <div className="col-6 col-md-4 mt-2">
            <label className="card-label">Date of Loss</label>
            <p className="card-value mb-0">
              {moment(props.detail.date_of_loss).format("DD/MM/YYYY")}
            </p>
          </div>
          <div className="col-6 col-md-4 mt-2">
            <label className="card-label">Insurer</label>
            <p className="card-value mb-0">
              {props.detail?.policy_detail?.insurer_name}
            </p>
          </div>
          <div className="col-6 col-md-4 mt-2">
            <label className="card-label">Nature of Claim</label>
            <p className="card-value mb-0">{props.detail.nature_of_claim}</p>
          </div>
          {/* <div className="col-6 col-md-4 mt-2">
          <label className="card-label">Department</label>
          <p className="card-value mb-0">
            {props.detail.policy_detail?.department}
            {'key missing in response'}
          </p>
        </div> */}
          <div className="col-6 col-md-4 mt-2">
            <label className="card-label">Claim Description</label>
            <p className="card-value mb-0">{props.detail.loss_details}</p>
          </div>
          <div className="col-6 col-md-4 mt-2">
            <label className="card-label">Loss Location</label>
            <p className="card-value mb-0">{props.detail.loss_location}</p>
          </div>
          <div className="col-6 col-md-4 mt-2">
            <label className="card-label">Claim Type</label>
            <p className="card-value mb-0">
              {/* {props.detail.claim_type.replace(/_/g, " ")} */}
              {props.detail.claim_type}
            </p>
          </div>
          <div className="col-6 col-md-4 mt-2">
            <label className="card-label">Claim Closed Date</label>
            <p className="card-value mb-0">
              {
                props.detail.claim_closed_date && props.detail.claim_closed_date !== null ?
                  moment(props.detail.claim_closed_date).format("DD/MM/YYYY") : '-'
              }
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-6 col-md-4 mt-2">
            <label className="card-label">Claim Handler Name</label>
            <p className="card-value mb-0">
              {props.detail.claim_handler_name ? props.detail.claim_handler_name : "-"}
            </p>
          </div>
          <div className="col-6 col-md-4 mt-2">
            <label className="card-label">Claim Handler Email</label>
            <p className="card-value mb-0">
              {props.detail.claim_handler_email ? props.detail.claim_handler_email : "-"}
            </p>
          </div>
          {/* <div className="col-6 col-md-4 mt-2">
            <label className="card-label">Claim Handler Branch</label>
            <p className="card-value mb-0">
              {props.detail.claim_handler_branch ? props.detail.claim_handler_branch : "-"}
            </p>
          </div> */}
        </div>
        <div className="row">
          <div className="col-12 mt-3">
            <h6>Documents({props.detail.employeeClaimDocument?.length})</h6>
          </div>
          {renderDocuments(props.detail.employeeClaimDocument)}
        </div>
        <div className="row justify-content-end mt-2">
          <div className="col">
            {/* <div className="text-end mt-1">
              <label className="card-label text-primary small">RM Name : {props.detail?.policy_detail?.rm_name}</label>
            </div> */}
            {/* <div className="text-end mt-1">
              <label className="card-label text-primary small">RM Contact Person : {props.detail?.claim_handler_name ? props.detail?.claim_handler_name : '-'}</label>
            </div> */}
          </div>
        </div>

      </div>
      


      <div className="row border-top pt-2 mt-1 fs-7">
        <div className="col-md-6 fw-bold border-end">
          Created On:{" "}
          <span>{moment(props.detail?.created_at).format("DD/MM/YYYY")}</span>
        </div>
        <div className="col-md-6 fw-bold border-end">
          Modified On:{" "}
          <span>{moment(props.detail?.updated_at).format("DD/MM/YYYY")}</span>
        </div>
      </div>
      </div>
      </div>
      </span>
    </>
  );
};
export default ClaimCard;
